import { Button } from "components/DesignSystem/Button/Button";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import { FormikForm } from "components/FormikForm/FormikForm";
import { Cross } from "components/icons/Cross";
import { useState } from "react";

type PinPopoverProps = {
  x: number; // percentage 0-100 within the page
  y: number; // percentage 0-100 within the page
  onClose: () => void;
  onAdd: (text: string) => void;
};

export const PinPopover = ({ x, y, onClose, onAdd }: PinPopoverProps) => {
  const [text, setText] = useState("");

  const handleAdd = () => {
    if (!text.trim()) return;
    onAdd(text.trim());
    setText("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleAdd();
    }
    if (e.key === "Escape") onClose();
  };

  const translateX = x > 60 ? "-100%" : "0%";
  const translateY = y > 60 ? "-100%" : "0%";

  return (
    <div
      className="t-absolute t-z-10 t-w-72 t-rounded-lg t-bg-surface t-shadow-light-60 t-border t-border-solid t-border-neutral-10"
      style={{
        left: `${x}%`,
        top: `${y}%`,
        transform: `translate(${translateX}, ${translateY})`,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="t-flex t-items-center t-justify-between t-px-3 t-pt-3 t-pb-2">
        <span className="t-text-body-sm t-font-medium t-text-text-100">
          Add question
        </span>
        <Button customType="ghost_icon" size="xsmall" onClick={onClose}>
          <Cross size="12" />
        </Button>
      </div>

      <div className="t-px-3 t-pb-3 t-flex t-flex-col t-gap-2">
        <FormikForm
          initialValues={{ text: "" }}
          onSubmit={() => {}}
          enableReinitialize
        >
          {() => (
            <TextArea
              name="text"
              placeholder="Type your question here"
              rows={2}
              size="small"
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
            />
          )}
        </FormikForm>

        <Button
          type="button"
          customType="primary"
          size="small"
          disabled={!text.trim()}
          onClick={handleAdd}
        >
          Add
        </Button>
      </div>
    </div>
  );
};
